import { render, staticRenderFns } from "./UpLoadMp4.vue?vue&type=template&id=0c817fcf&scoped=true&"
import script from "./UpLoadMp4.vue?vue&type=script&lang=js&"
export * from "./UpLoadMp4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c817fcf",
  null
  
)

export default component.exports